import { useEffect } from "react";

/**
 * Wires up the homepage "reveal on scroll" animation for any page that uses
 * the `.jjfv2` design system. Elements with the `.reveal` class start hidden
 * (opacity:0) in homeV2.css and become visible once they enter the viewport.
 *
 * Pass a ref to the page root so only that subtree is observed.
 */
export default function useScrollReveal(ref) {
  useEffect(() => {
    const root = ref?.current;
    if (!root) return;

    const els = root.querySelectorAll(".reveal");

    // Graceful fallback: if IntersectionObserver is unavailable, just show
    // everything so content is never stuck invisible.
    if (typeof IntersectionObserver === "undefined") {
      els.forEach((el) => el.classList.add("in"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [ref]);
}
